import { Outlet, useLoaderData, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '@cere/cere-design-system';
import { loadRuntimeConfig, type RuntimeConfig } from '@/src/config/runtime';
import { ConfigProvider } from '@/src/config/context';

export async function rootLoader(): Promise<RuntimeConfig> {
  return await loadRuntimeConfig();
}

export function RootLayout() {
  const config = useLoaderData() as RuntimeConfig;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ConfigProvider value={config}>
        <Outlet />
      </ConfigProvider>
    </ThemeProvider>
  );
}

export function RootErrorBoundary() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong.';
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ padding: 24, maxWidth: 520, margin: '64px auto', fontFamily: 'system-ui' }}>
        <h1 style={{ fontSize: 18, marginBottom: 8 }}>Vault failed to load</h1>
        <p style={{ color: '#666' }}>{message}</p>
      </div>
    </ThemeProvider>
  );
}
